<h2 mat-dialog-title>{{header}}</h2>
<mat-dialog-content>
   <div class="mialog-description">
    <p>{{ data.message }}</p>
   </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="action-button">
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
        <button mat-button mat-dialog-close (click)="onConfirmClick()">{{data.btnText }}</button>
    </div>
</mat-dialog-actions>